import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {PostProcessRender} from "@cm/template-nodes"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ToneMappingInspectorComponent} from "@app/template-editor/components/inspectors/tone-mapping-inspector/tone-mapping-inspector.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-post-process-render-inspector",
    templateUrl: "./post-process-render-inspector.component.html",
    styleUrl: "./post-process-render-inspector.component.scss",
    imports: [ValueSlotComponent, InspectorSectionComponent, ToneMappingInspectorComponent],
})
export class PostProcessRenderInspectorComponent extends BaseInspectorComponent<PostProcessRender, {}> {
    readonly $lutPossibilites = signal<SelectionPossibilities<string>>([
        {value: "https://storage.googleapis.com/cm-platform-prod-static/LUTs/Kim_Amland_Photographic_01.cube", name: "Photographic 1"},
        {value: "https://storage.googleapis.com/cm-platform-prod-static/LUTs/Kim_Amland_Photographic_02.cube", name: "Photographic 2"},
        {value: "https://storage.googleapis.com/cm-platform-prod-static/LUTs/Kim_Amland_Photographic_03.cube", name: "Photographic 3"},
        {value: "https://storage.googleapis.com/cm-platform-prod-static/LUTs/RT_film_curve_03_no_hc.cube", name: "RT Film Curve 03"},
    ])
}
